import { Link, useSearchParams } from "react-router-dom";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { HealthyContactEmbed } from "@/components/site/HealthyContactEmbed";
import {
  DrugTestingHero,
  DrugTestingPageShell,
  useDrugTestingCopy
} from "@/components/site/drug-testing/DrugTestingShared";
import { HEALTHY_CONTACT_FORM_URL } from "@/data/certificateBookingActions";
import { companyDrugQuoteHref } from "@/data/drugTesting";
import { PageMeta } from "@/components/site/PageMeta";

const DrogtestningForfragan = () => {
  const { lang, copy } = useDrugTestingCopy();
  const [searchParams] = useSearchParams();
  const e = copy.enquiry;
  const purpose = searchParams.get("andamal") === "intyg" ? "intyg" : "privat";
  const sample = searchParams.get("prov");



  return (
    <DrugTestingPageShell breadcrumb={[{ label: e.label }]}>
      <PageMeta title={e.metaTitle} description={e.metaDescription} />
      <DrugTestingHero label={e.label} title={e.title}>
        <p>{e.subtitle}</p>
      </DrugTestingHero>

      <section className="py-14 lg:py-16">
        <div className="container-wide grid gap-8 lg:grid-cols-[1.5fr_1fr]">
          <div className="overflow-hidden rounded-3xl border border-border bg-card shadow-card">
            <HealthyContactEmbed
              key={`${purpose}-${sample ?? "none"}`}
              src={HEALTHY_CONTACT_FORM_URL}
              title={e.title}
              className="bg-card"
              iframeClassName="h-[70vh] min-h-[560px] w-full border-0"
            />
          </div>
          <aside className="rounded-3xl border border-border/60 bg-card p-7 shadow-card h-fit">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary-soft text-primary">
              <Phone className="h-5 w-5" aria-hidden />
            </span>
            <h2 className="mt-5 font-display text-xl font-semibold text-foreground">{e.companyTitle}</h2>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{e.companyText}</p>
            <Button asChild variant="ghost-outline" size="lg" className="mt-6 w-full">
              <Link to={companyDrugQuoteHref(lang)}>{e.companyCta}</Link>
            </Button>
            <p className="mt-5 text-sm text-muted-foreground">
              {e.phoneText}{" "}
              <a href="tel:+46317617700" className="font-medium text-primary hover:text-primary/80">
                031-761 77 00
              </a>
              .
            </p>
          </aside>
        </div>
      </section>
    </DrugTestingPageShell>
  );
};

export default DrogtestningForfragan;
